/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { cloneElement, FC, isValidElement, MouseEvent, ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';
import { styled } from 'linaria/react';
import Swipe from 'react-easy-swipe';
import { withTheme } from '@shared/lib/theme';
import { usePortalById, useLockScroll, useBottomSheet } from '@shared/lib/react';
export interface BottomSheetProps {
  open: boolean;
  onClose: (e: MouseEvent<HTMLElement>) => void;
  children?: ReactNode;
  withBackdrop?: boolean;
}
export const BottomSheet: FC<BottomSheetProps> = ({
  open,
  onClose,
  children,
  withBackdrop = true
}) => {
  const sheetContainer = usePortalById('modal-container');
  const scrollableRef = useRef<HTMLElement>(null);
  const {
    visible,
    animationState,
    onSwipeStart,
    onSwipeMove,
    onSwipeEnd,
    handleModalClose
  } = useBottomSheet({
    open,
    onClose,
    scrollableRef
  });
  useLockScroll(open);
  if (!sheetContainer || !visible) return null;
  const childrenWithRef = isValidElement(children) ? cloneElement(children as React.ReactElement<{
    scrollableRef?: typeof scrollableRef;
  }>, {
    scrollableRef
  }) : children;
  return createPortal(<>
      {withBackdrop && <Backdrop onClick={handleModalClose} />}
      <SheetWrapper open={open || animationState === 'closing'}>
        {/* @ts-ignore */}
        <Swipe onSwipeStart={onSwipeStart} onSwipeMove={onSwipeMove} onSwipeEnd={onSwipeEnd}>
          <SheetContent data-state={animationState}>{childrenWithRef}</SheetContent>
        </Swipe>
      </SheetWrapper>
    </>, sheetContainer as Element);
};
export default BottomSheet;
const _exp = /*#__PURE__*/() => ({
  open
}) => open ? 'block' : 'none';
const _exp2 = /*#__PURE__*/() => ({
  open
}) => open ? 1 : 0;
const SheetWrapper = /*#__PURE__*/styled('div')({
  name: "SheetWrapper",
  class: "s15y0pim",
  propsAsIs: false,
  vars: {
    "s15y0pim-0": [_exp()],
    "s15y0pim-1": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.overlay.primary;
const Backdrop = withTheme(/*#__PURE__*/styled('div')({
  name: "Backdrop",
  class: "b1fxqr8g",
  propsAsIs: false,
  vars: {
    "b1fxqr8g-0": [_exp3()]
  }
}));
const SheetContent = /*#__PURE__*/styled('div')({
  name: "SheetContent",
  class: "s1d2pduj",
  propsAsIs: false
});

require("./BottomSheet.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./BottomSheet.tsx");